import React from 'react';
import ContactForm from '../ContactFrom'
import './style.css'

const Contactpage = () => {

    return (
        <section className="contact-pg-contact-section section-padding">
            <div className="container">
                <div className="row">
                    {/* Contact Details */}
                    <div className="col col-lg-6 col-12">
                        <div className="section-title-s3 section-title-s5">
                            <h2>Get in Touch</h2>
                        </div>
                        <div className="contact-details">
                            <p>
                                We would love to hear from you! Whether you’d like to enroll your child,
                                volunteer, or support our mission to bring Indian performing arts to every community,
                                feel free to reach out to us. Our team will be happy to guide you.
                            </p>
                            <ul>
                                <li>
                                    <div className="icon">
                                        <i className="ti-location-pin"></i>
                                    </div>
                                    <h5>Our Location</h5>
                                    <p>
                                        Plot No. 107,
                                        2nd Main Road,
                                        Srinivasapuram,
                                        Anagaputhur,
                                        Chennai – 600070
                                    </p>
                                </li>
                                <li>
                                    <div className="icon">
                                        <i className="ti-mobile"></i>
                                    </div>
                                    <h5>Phone</h5>
                                    <p>+91-9789990954</p>
                                </li>
                                <li>
                                    <div className="icon">
                                        <i className="ti-email"></i>
                                    </div>
                                    <h5>Email</h5>
                                    <p>nardhanamala@gmail.com</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="col col-lg-6 col-12">
                        <div className="contact-form-area">
                            <div className="section-title-s3 section-title-s5">
                                <h2>Send Us a Message</h2>
                            </div>
                            <div className="contact-form">
                                <ContactForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default Contactpage;
